import { Link } from "react-router-dom"
import DisconnectedNoTFN from "./DisconnectedNoTFN"
import { Heading } from "@planningcenter/doxy-web"
import ImageCarousel from "./ImageCarousel"
import { css } from "@emotion/react"
import { useGivingOrganizationContext } from "../../hooks/useGivingOrganizationContext"

export default function Disconnected() {
  const { givingOrganization } = useGivingOrganizationContext()
  return (
    <>
      {!givingOrganization.text2give_phone_number ? (
        <DisconnectedNoTFN />
      ) : (
        <div
          className="d-f fd-c g-2 p-2"
          css={css`
            border: 1px solid var(--color-tint6);
            border-radius: 8px;
          `}
        >
          <p className="mb-3">
            To get started, text <strong>GIVE</strong> and the amount you want
            to give to{" "}
            <strong>
              {givingOrganization.formatted_text2give_phone_number}
            </strong>
            .{" "}
            <Link to="/giving/text-to-give/help" className="fw-500">
              Learn more
            </Link>
            , or{" "}
            <Link to={`sms:${givingOrganization.text2give_phone_number}`}>
              tap here to start a text to {givingOrganization.name}.
            </Link>
          </p>

          <div className="action-drawer p-2 d-f fd-c g-1">
            <Heading level={2} text="Example" />
            <ImageCarousel />
          </div>
        </div>
      )}
    </>
  )
}
